// frontend/src/pages/builder/ChartTypeSwitcher.jsx
// Phase 3 step 7a, restyled in 7c-2: a tile per chart type, each drawn as a
// tiny real chart (ChartGlyph). A type the current fields can't draw stays
// visible but faded, and pointing at it (mouse or keyboard focus) shows why
// in a tooltip. Faded tiles stay focusable (aria-disabled, not disabled) so
// keyboard and screen-reader users get the reason too.
import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import ChartGlyph from '../../charts/ChartGlyph';
import { CHART_TYPES } from './chartTypes';

export default function ChartTypeSwitcher({ value, reasons, onChange }) {
  const current = CHART_TYPES.find((t) => t.id === value);
  const anyBlocked = CHART_TYPES.some((t) => reasons[t.id] != null);

  return (
    <TooltipProvider delayDuration={150}>
      <div role="group" aria-label="Chart type" className="grid grid-cols-5 gap-1.5">
        {CHART_TYPES.map((t) => {
          const reason = reasons[t.id];
          const active = t.id === value;
          const blocked = reason != null;
          return (
            <Tooltip key={t.id}>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  aria-pressed={active} aria-disabled={blocked || undefined}
                  aria-label={blocked ? `${t.label}: ${reason}` : t.label}
                  onClick={() => { if (!blocked) onChange(t.id); }}
                  className={`flex h-[52px] items-center justify-center rounded-xl transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 ${
                    active ? 'bg-[#232323] shadow-[inset_0_0_0_1.5px_var(--ui-selected)]'
                      : blocked ? 'cursor-not-allowed bg-[var(--ui-inset)]'
                        : 'bg-[var(--ui-inset)] hover:bg-[var(--ui-inset-hover)]'}`}
                >
                  <ChartGlyph type={t.id} muted={blocked} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom">
                {blocked ? <><span className="font-semibold">{t.label}</span> · {reason}</> : t.label}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-[var(--ui-text-muted)]">
        <span className="font-medium text-[var(--ui-text)]">{current ? current.label : ''}</span>
        {anyBlocked && ' · faded types don’t fit these fields'}
      </p>
    </TooltipProvider>
  );
}